import dayjs, { ConfigType } from 'dayjs';
import timezone from 'dayjs/plugin/timezone'; // ES 2015
import utc from 'dayjs/plugin/utc'; // ES 2015

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 如有新增的国家，参考下面文档：
 * https://www.zeitverschiebung.net/cn/country/tr
 * https://www.geonames.org/search.html
 */
export const TimezoneMap = Object.freeze({
  // 沙特时间
  Arabia: 'Asia/Riyadh',
  // 土耳其时间
  Turkey: 'Europe/Istanbul',
  // 印度时间
  India: 'Asia/Kolkata',
});

export const time = (value: number, format = 'YYYY-MM-DD HH:mm:ss', timezone?: string) => {
  if (!value) return undefined;
  if (String(value).length <= 10) {
    value *= 1000;
  }
  if (!timezone) return dayjs(value).format(format);
  return dayjs(value).tz(timezone).format(format);
};

// 土语区默认时间格式转换：日-月-年 时:分:秒
export const timeTr = (value: number, format = 'DD-MM-YYYY HH:mm:ss') => {
  if (!value) return undefined;
  if (String(value).length <= 10) {
    value *= 1000;
  }
  return dayjs(value).format(format);
};

export const unix = (value: ConfigType) => {
  return dayjs(value || 0).unix();
};

function calc(ms: number) {
  return function (quantity: number) {
    return Math.round(ms * quantity);
  };
}

function createTimeConfig(base = 1) {
  return {
    seconds: base,
    minutes: base * 60,
    hours: base * 60 * 60,
    days: base * 24 * 60 * 60,
    weeks: base * 7 * 24 * 60 * 60,
    months: base * 30 * 24 * 60 * 60,
    years: base * 365 * 24 * 60 * 60,
  };
}

const MILLISECONDS = createTimeConfig(1000);

export const timeMilliseconds = {
  seconds: calc(MILLISECONDS.seconds),
  minutes: calc(MILLISECONDS.minutes),
  hours: calc(MILLISECONDS.hours),
  days: calc(MILLISECONDS.days),
  weeks: calc(MILLISECONDS.weeks),
  months: calc(MILLISECONDS.months),
  years: calc(MILLISECONDS.years),
};

const SECONDS = createTimeConfig(1);

export const timeSeconds = {
  seconds: calc(SECONDS.seconds),
  minutes: calc(SECONDS.minutes),
  hours: calc(SECONDS.hours),
  days: calc(SECONDS.days),
  weeks: calc(SECONDS.weeks),
  months: calc(SECONDS.months),
  years: calc(SECONDS.years),
};

export const getCurrentMonthDayCount = (timestamp: number) => {
  // return dayjs(timestamp).daysInMonth();
  const timezone = 8; // 目标时区时间，东八区
  const offsetGMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
  const date = new Date(timestamp + offsetGMT * 60 * 1000 + timezone * 60 * 60 * 1000);
  const month = date.getMonth();
  if (month === 11) {
    const year = date.getFullYear() + 1;
    date.setFullYear(year, 0, 0);
  } else {
    date.setMonth(month + 1, 0);
  }
  return date.getDate();
};

// 获取本月最后一秒  做月倒计时
export const getMonthLastTime = (timestamp: number) => {
  // 一月共有多少天
  const days = getCurrentMonthDayCount(timestamp);
  const lastTime = timestamp + days * 24 * 60 * 60 * 1000;

  return lastTime;
};

/**
 * 获取本地时区展示字符串
 * @returns UTC+8
 */
export const getTimeZoneString = () => {
  const timeZone = new Date().getTimezoneOffset() / 60;
  return `UTC${timeZone > 0 ? '-' : '+'}${Math.abs(timeZone)}`;
};

/**
 * 获取指定日期所在周的周一日期
 * @param timestamp 时间戳（毫秒）
 * @param timezone 时区
 * @returns 周一的时间戳（毫秒）
 */
export const getMonday = (timestamp?: number, timezone?: string) => {
  const date = timestamp ? dayjs(timestamp) : dayjs();
  const day = date.day(); // 0是周日，1是周一，2是周二...
  const mondayOffset = day === 0 ? -6 : 1 - day; // 计算到周一的偏移天数

  const monday = date.add(mondayOffset, 'day').startOf('day');

  if (timezone) {
    return monday.tz(timezone).valueOf();
  }

  return monday.valueOf();
};
